import { useState } from 'react';
import { Alert } from 'react-bootstrap';

import { useLocalStorage } from '../../helpers/localStorage';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../generic/Button';
import Icon, { icons } from '../generic/Icon';

import styles from './ApplicationMobileWarning.module.less';

const MOBILE_WARNING_DISMISSED_KEY = '__FOSSA_MOBILE_WARNING_DISMISSED__';

/**
 * Warning which overlays the entire app if the viewport width is too small, telling the
 * user that FOSSA works best on desktop. It can be dismissed, after which a persistent
 * red banner is shown at the top of the page instead.
 *
 * Both states are hidden above the breakpoint by CSS, so there's no resize listener here.
 */
const ApplicationMobileWarning = () => {
  const dismissedStorage = useLocalStorage<boolean>(MOBILE_WARNING_DISMISSED_KEY);
  const [isDismissed, setIsDismissed] = useState(() => dismissedStorage.get() === true);

  if (isDismissed) {
    return (
      <div className={styles.mobileBanner}>
        <Alert bsStyle="neworg">
          This screen size is not supported. FOSSA may not display or work correctly.
        </Alert>
      </div>
    );
  }

  return (
    <div className={styles.mobileWarning}>
      <div
        aria-labelledby="mobile-warning-heading"
        aria-modal="true"
        className={styles.mobileWarningCard}
        role="dialog"
      >
        <span className={styles.mobileWarningCardIcon}>
          <Icon icon={icons.desktop} />
        </span>
        <h2 className={styles.mobileWarningCardHeading} id="mobile-warning-heading">
          FOSSA works best on desktop
        </h2>
        <p className={styles.mobileWarningCardBody}>
          You can keep browsing and working here, but some features may not work as expected on
          mobile.
        </p>
        <p className={styles.mobileWarningCardBody}>
          For the full experience, switch to a desktop browser.
        </p>
        <Button
          className={styles.mobileWarningCardButton}
          isFullWidth
          onClick={() => {
            dismissedStorage.set(true);
            setIsDismissed(true);
          }}
          size={BUTTON_SIZE.LARGE}
          type={BUTTON_TYPE.PRIMARY}
        >
          Continue on Mobile
        </Button>
      </div>
    </div>
  );
};

export default ApplicationMobileWarning;
